class WelcomePopup extends HTMLElement {
  #storageKey = 'conv_welcome_seen';

  connectedCallback() {
    if (localStorage.getItem(this.#storageKey)) return;
    if (Shopify?.designMode) return;

    const delay = parseInt(this.dataset.delay || '5000', 10);
    setTimeout(() => this.#show(), delay);

    this.querySelectorAll('[data-close]').forEach((el) => {
      el.addEventListener('click', () => this.#close());
    });

    const copyBtn = this.querySelector('[data-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        const coupon = this.dataset.coupon;
        if (coupon) {
          navigator.clipboard.writeText(coupon).then(() => {
            copyBtn.textContent = 'Kopyalandı!';
            setTimeout(() => { copyBtn.textContent = 'Kopyala'; }, 2000);
          });
        }
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.classList.contains('hidden')) this.#close();
    });
  }

  #show() {
    this.classList.remove('hidden');
  }

  #close() {
    this.classList.add('hidden');
    localStorage.setItem(this.#storageKey, '1');
  }
}

if (!customElements.get('welcome-popup')) {
  customElements.define('welcome-popup', WelcomePopup);
}
